// src/Scene.js
import React, { useRef, useEffect } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';

function Model({ url }) {
  const { scene } = useGLTF(url);
  const modelRef = useRef();

  // Rotate the model continuously
  useFrame(() => {
    if (modelRef.current) {
      modelRef.current.rotation.y += 0.01;
    }
  });

  return <primitive ref={modelRef} object={scene} scale={6} position={[0, -1, 0]} />;
}

function Scene() {
  const baseUrl = process.env.PUBLIC_URL || "";

  return (
    <Canvas camera={{ position: [0, 2, 5] }}>
      <ambientLight intensity={0.8} />
      <directionalLight position={[2, 5, 2]} intensity={1} />
      <Model url={`${baseUrl}/rextifire_logo.glb`} />
      <OrbitControls enableZoom={true} />
    </Canvas>
  );
}

export default Scene;
